import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import PayeeType from 'models/claims/payeeType/Model.PayeeType';
import { PayeeTypeAction, usePayeeTypeProvider } from '../PayeeType.Hooks';

export default function PayeeTypeList() {
  const { lang } = getLocales();
  const { listApi, pageRouter } = usePayeeTypeProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.payeeTypes}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple} data-loading={listApi.isExecuting ? true : undefined}>
      <thead>
        <tr>
          <th>{lang.name}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: payeeType }) => (
            <tr key={payeeType.id}>
              <td>
                <b>{payeeType.name}</b>
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: payeeType.id.toString(),
                      action: PayeeTypeAction.EDIT,
                    }}
                    disabled={payeeType.id <= PayeeType.REPAIR_FACILITY_ID}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                    media={<Icon class="fas-edit" />}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: payeeType.id.toString(),
                      action: PayeeTypeAction.DELETE,
                    }}
                    disabled={payeeType.id <= PayeeType.REPAIR_FACILITY_ID}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                    media={<Icon class="fas-trash" />}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
